import { useSelector } from 'react-redux';

import { RootStateType } from 'store/reducers';

const useIsFreeTier = (): boolean => {
  const { activeSubscription } = useSelector((state: RootStateType) => state.payment);
  return activeSubscription ? activeSubscription.isFreeTier : false;
};

export default useIsFreeTier;